// extracted by mini-css-extract-plugin
export default {"ExternalLinkButton":"ExternalLinkButton-module-c8f00871eed5dfb2c0b5"};